import { render } from "./SetNewPass.vue?vue&type=template&id=3dc2baa9&ts=true"
import script from "./SetNewPass.vue?vue&type=script&lang=ts"
export * from "./SetNewPass.vue?vue&type=script&lang=ts"

import "./SetNewPass.vue?vue&type=style&index=0&id=3dc2baa9&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Basseliersstraat\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__